import * as Dialog from '@radix-ui/react-dialog'
import { useAppStore } from '@store'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export function OpenProjectModal() {
  const navigate = useNavigate()
  const closeModal = useAppStore.use.closeModal()
  const openModal = useAppStore.use.openModal()
  const setStoreFromBack = useAppStore.use.setStoreFromBack()
  const setMode = useAppStore.use.setMode()
  const { idVersiones, _idVersiones } = useParams()
  const idVers = Number(idVersiones)
  const setOBBS = useAppStore.use.setOBBScene()

  async function handleOpenProject() {
    openModal()
    navigate('/planner/downloading')
    await setStoreFromBack(idVers)
    setTimeout(() => {
      // Activar cotas al abrir proyecto
      const setHideDimentions3D = useAppStore.getState().setHideDimentions3D
      setHideDimentions3D(false)
      setMode('MODE_IDLE')
      closeModal()
      navigate('/planner')
      setOBBS()
    }, 2000)
  }

  function handleSaveAndOpen() {
    // Guardar el idVers del proyecto a abrir después de guardar
    localStorage.setItem('pendingAction', 'openProjectAfterSave')
    localStorage.setItem('pendingFrom', 'openProject')
    localStorage.setItem('pendingProjectIdVers', String(idVers))
    sessionStorage.setItem('pendingSave', 'true')
    closeModal()
    navigate('/planner/saveProject')
  }

  function handleCancel() {
    closeModal()
    navigate(-1)
  }

  useEffect(() => {
    openModal()
    return () => closeModal()
  }, [])

  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Overlay className='z-90 fixed inset-0 bg-black bg-opacity-30' />
        <Dialog.Content className='text-md absolute left-1/2 top-1/2 z-50 h-min w-72  -translate-x-1/2 -translate-y-1/2 border-2 border-colorAtemporal bg-C/Color1 p-4 text-left'>
          <Dialog.Title className='sr-only'>{'¿Seguro que quieres hacer eso?'}</Dialog.Title>
          <Dialog.Description className='sr-only'>{'Abrir Proyecto'}</Dialog.Description>
          <div className='flex flex-col items-center justify-center gap-y-2'>
            <p className='text-center font-normal'>
              {'¿Quieres guardar el proyecto antes de crear uno nuevo?'}
            </p>
            <div className='mt-4 flex w-full justify-center gap-3'>
              <button
                onClick={handleSaveAndOpen}
                className='flex cursor-pointer items-center rounded-xl border border-solid border-C/Color7 bg-colorAtemporal px-4 text-sm font-normal text-C/Color1'
              >
                {'Sí'}
              </button>
              <button
                onClick={handleOpenProject}
                className='flex cursor-pointer items-center rounded-xl border border-C/Color3 bg-C/Color7 px-4 py-0.5 text-sm font-normal text-C/Color3'
              >
                {'No'}
              </button>
              <button
                onClick={handleCancel}
                className='flex cursor-pointer items-center rounded-xl border border-C/Color3 bg-C/Color7 px-4 py-0.5 text-sm font-normal text-C/Color3'
              >
                {'Cancelar'}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
